<template>
  <div id="searchform">
    <v-dialog v-model="showDialog" max-width="500">
      <v-card>
        <v-card-title class="headline">{{ msg }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="indigo white--text" depressed @click="showDialog = false">Ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="show429Dialog" max-width="500">
      <v-card>
        <v-card-title class="headline white--text" style="background-color: #c62828;">
          Too Many Requests
        </v-card-title>
        <v-card-text class="pt-4 subtitle-1">{{ msg429 }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-3 white--text" depressed @click="show429Dialog = false">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-container id="searchform__container">
      <v-row no-gutters id="searchform__searchbox" class="pa-0 ma-0">
        <v-col :cols="6">
          <v-text-field v-model="searchquery" label="Search" v-on:keyup.enter="search" ref="fontsize1" outlined dense
            clearable prepend-inner-icon="mdi-search-web" />
          <SenderListTooltip v-if="senderList.length" :senders="senderList" @chooseSender='chooseSender'
            v-click-outside="closeSenderList" />
        </v-col>
        <div id="searchform__button--2">
          <v-btn color="indigo white--text" @click.prevent="search" depressed ref="btn1">Search</v-btn>
        </div>
        <div id="searchform__button--3">
          <v-btn color="indigo white--text" @click.prevent="clearSearch" depressed ref="btn2">Clear</v-btn>
        </div>
      </v-row>
      <v-row no-gutters>
        <v-col :cols="6">
          <v-row align="center" no-gutters>
            <v-col cols="2" no-gutters>
              <v-checkbox label="ID" ref="fontsize2" v-model="searchbyid" />
            </v-col>
            <v-col cols="2">
              <v-checkbox label="Subject" ref="fontsize3" v-model="searchbysubject" />
            </v-col>
            <v-col cols="2">
              <v-checkbox label="Body" ref="fontsize4" v-model="searchbybody" />
            </v-col>
            <v-col cols="3">
              <v-checkbox label="Sender Name" ref="fontsize5" v-model="searchbysendername" />
            </v-col>
            <v-col cols="3">
              <v-checkbox label="Sender Email" ref="fontsize6" v-model="searchbysenderemail" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col :cols="5">
          <v-row>
            <v-col cols="1" class="middle__align"><b>From</b></v-col>
            <v-col cols="4">
              <v-select :items="months" dense solo hide-details="true" class="select__item" v-model="from_month"
                ref="select__2"></v-select>
            </v-col>
            <v-col cols="3">
              <v-select :items="days" dense solo hide-details="true" class="select__item" v-model="from_day"
                ref="select__1"></v-select>
            </v-col>
            <v-col cols="4">
              <v-select :items="years" dense solo hide-details="true" class="select__item" v-model="from_year"
                ref="select__3"></v-select>
            </v-col>
          </v-row>
        </v-col>
        <v-col :cols="5">
          <v-row>
            <v-col cols="1" class="middle__align"><b>To</b></v-col>
            <v-col cols="4">
              <v-select :items="months" dense solo hide-details="true" class="select__item" v-model="to_month"
                ref="select__5"></v-select>
            </v-col>
            <v-col cols="3">
              <v-select :items="days" dense solo hide-details="true" class="select__item" v-model="to_day"
                ref="select__4"></v-select>
            </v-col>
            <v-col cols="4">
              <v-select :items="years" dense solo hide-details="true" class="select__item" v-model="to_year"
                ref="select__6"></v-select>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row no-gutters v-if="dashboardType != 'junk'">
        <ul id="searchform__list">
          <li>
            <v-checkbox v-model="email_show_blank" label="Show blank" no-gutters ref="fontsize6" />
          </li>
          <li>
            <v-checkbox v-model="email_show_unused" label="Show unused" no-gutters ref="fontsize7" />
          </li>
          <li>
            <v-checkbox v-model="email_show_used" label="Show used" no-gutters ref="fontsize8" />
          </li>
          <!-- <li>
            <v-checkbox
              v-model="email_show_junk"
              label="Show junk"
              no-gutters
              ref="fontsize9"
            />
          </li> -->
          <li>
            <v-checkbox v-model="email_show_copy" label="Show copy" no-gutters ref="fontsize10" />
          </li>
          <li>
            <v-checkbox v-model="hideMarkedRead" label="Hide Marked Read" no-gutters ref="fontsize11" />
          </li>
        </ul>
      </v-row>
      <v-row align="center" no-gutters>
        <ul id="searchform__list">
          <li class="middle__align">
            <b>Flags</b>
          </li>
          <li v-if="pan !== 'producer'">
            <v-checkbox v-model="flags_c" label="C" ref="fontsize12" />
          </li>
          <li v-if="pan !== 'producer'">
            <v-checkbox v-model="flags_en" label="EN" ref="fontsize13" />
          </li>
          <li v-if="pan !== 'producer'">
            <v-checkbox v-model="flags_n" label="N" ref="fontsize14" />
          </li>
          <li v-if="pan !== 'producer'">
            <v-checkbox v-model="flags_rl" label="RL" ref="fontsize15" />
          </li>
          <li v-if="pan !== 'producer'">
            <v-checkbox v-model="flags_tc" label="TC" ref="fontsize16" />
          </li>
          <li v-if="pan !== 'producer'">
            <v-checkbox v-model="flags_tl" label="TL" ref="fontsize17" />
          </li>

          <li v-if="pan !== 'producer'">
            <v-checkbox v-model="flags_ae" label="AE" ref="fontsize17" />
          </li>
          <li v-if="pan !== 'producer'">
            <v-checkbox v-model="flags_po" label="PO" ref="fontsize17" />
          </li>
          <li v-if="pan !== 'producer'">
            <v-checkbox v-model="flags_hr" label="HR" ref="fontsize17" />
          </li>
          <li v-if="pan !== 'producer'">
            <v-checkbox v-model="flags_re" label="RE" ref="fontsize17" />
          </li>

          <li v-if="pan === 'producer'">
            <v-checkbox v-model="flags_id" label="ID" ref="fontsize18" />
          </li>
          <li v-if="pan === 'producer'">
            <v-checkbox v-model="flags_pt" label="PT" ref="fontsize19" />
          </li>
          <li v-if="pan === 'producer'">
            <v-checkbox v-model="flags_pn" label="PN" ref="fontsize20" />
          </li>
        </ul>
      </v-row>
      <v-row no-gutters>
        <v-col cols="6" no-gutters>
          <v-text-field v-model="panelist" label="Panelist" no-gutters ref="fontsize21" outlined dense />
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col cols="2" no-gutters>
          <v-select :items="states" dense solo hide-details="true" class="select__item" v-model="state"
            ref="select__7"></v-select>
        </v-col>
        <v-col cols="8" no-gutters>
          <v-radio-group v-model="country" :mandatory="false">
            <v-row align="center" no-gutters>
              <v-col cols="2" no-gutters>
                <v-radio label="All" value="0" ref="fontsize22" />
              </v-col>
              <v-col cols="2">
                <v-radio label="Canada" value="CA" ref="fontsize23" />
              </v-col>
              <v-col cols="4">
                <v-radio label="United States" value="US" ref="fontsize24" />
              </v-col>
            </v-row>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col cols="2" no-gutters>
          <v-card-text class="font12"><b>Owner Type</b></v-card-text>
        </v-col>
        <v-col cols="8" no-gutters>
          <v-radio-group v-model="businessOwener" :mandatory="false" no-gutters>
            <v-row align="center" no-gutters>
              <v-col cols="2" no-gutters>
                <v-radio label="Business Owner" value="1" ref="fontsize25" />
              </v-col>
              <v-col cols="2" no-gutters>
                <v-radio label="Both" value="-1" ref="fontsize26" />
              </v-col>
              <v-col cols="4" no-gutters>
                <v-radio label="Non-Business Owner" value="0" ref="fontsize27" />
              </v-col>
            </v-row>
          </v-radio-group>
        </v-col>
      </v-row>

    </v-container>
  </div>
</template>
<script>
import SenderListTooltip from '../utilities/SenderListTooltip'

export default {
  name: "SearchForm",
  data: () => ({
    // searchquery: ''
    showDialog: false,
    msg: "",
    oldQuery: "",
    states: [],
    senderList: [],
    show429Dialog: false,
    msg429: "",
    // clear_flag: false,
    // search_flag:false
  }),
  props: [
    "dashboardType"
  ],
  components: {
    SenderListTooltip,
  },
  mounted() {
    for (var i = 1; i < 28; i++) {
      let e = this.$refs["fontsize" + i];
      if (typeof e !== "undefined") {
        e.$refs.label.style.fontSize = "12px";
      }
    }
    for (i = 1; i < 8; i++) {
      this.$refs["select__" + i].$refs.input.style.display = "none";
    }
    let nodes = document.querySelectorAll(".v-messages"),
      size = nodes.length;
    for (i = 0; i < size; i++) {
      nodes[i].style.display = "none";
    }
    (nodes = document.querySelectorAll(".v-text-field__details")),
      (size = nodes.length);
    for (i = 0; i < size; i++) {
      nodes[i].style.display = "none";
    }
    this.$refs.btn1.$refs.link.style.fontSize = "13.5px";
    this.$refs.btn2.$refs.link.style.fontSize = "13.5px";
    for (var k in this.$refs.select__7.$refs) {
      if (k === "input-slot") {
        this.$refs.select__7.$refs[k].style.fontWeight = 500;
      }
    }
    this.states = this.$store.getters["RawData/getStates"];
  },
  methods: {
    clearSearch: function () {


      var view = this;
      //  view.clear_flag = true;
      // myPromise= new Promise(function (resolve) {
      let updateObjects = view.$store.getters["Emails/getUpdateObjects"];
      if (Array.isArray(updateObjects) && updateObjects.length) {
        if (!confirm("Do you really want to continue with unsaved changes?")) {
          return;
        }
      }
      view.$store.dispatch('Emails/removeAllUpdateObj', [])
      // var view = this;
      var refs = view.$store.getters["RawData/getEmailsItemRefs"];
      if (refs.length > 0) {
        refs.forEach(function (o) {
          o.checkThisEmail(false);
        });
      }
      view.oldQuery = "";
      view.$store.dispatch("Emails/setUpdateObjectsEmpty", []);
      view.$store.dispatch("Search/setSearchBySenderName", false);
      view.$store.dispatch("Search/setSearchBySenderEmail", false);
      view.$store
        .dispatch("Search/resetState", {})
        .then(function () {
          return view.$store.dispatch("Emails/setPerPage", 10);
        })
        .then(function () {
          return view.$store.dispatch("Emails/setPage", 1);
        })
        .then(function () {
          return view.$store.dispatch("Search/setIsFromSearch", false);
        })
        .then(function () {
          return view.$store.dispatch(
            "Emails/setStartTime",
            new Date().getTime()
          );
        })
        .then(function () {
          return view.$store.dispatch("Emails/setSortingField", "email_date");
        })
        .then(function () {
          return view.$store.dispatch("Emails/setSortingDirection", "desc");
        })
        .then(function () {
          return view.$utils.search(view)

        })
        // .then(function (promise_res) {
        //   if (promise_res === true) {
        //     view.clear_flag = false
        //   }

        // })
        .catch(function (e) {
          if (e && (e.is429 || e.status === 429 || (e.response && e.response.status === 429))) {
            view.handle429(e);
          } else {
            console.log(e);
          }
        });

    },
    handle429: function (e) {
      let message = "Too many requests. Please wait a moment and try again.";
      if (e && e.message) {
        message = e.message;
      } else if (e && e.response) {
        message = e.response.data?.message || e.response.data || message;
      }
      this.msg429 = message;
      this.show429Dialog = true;
    },
    search: function () {
      var view = this;
      // view.search_flag = true;
      let updateObjects = view.$store.getters["Emails/getUpdateObjects"];
      if (Array.isArray(updateObjects) && updateObjects.length) {
        if (!confirm("Do you really want to continue with unsaved changes?")) {
          return;
        }
      }
      view.$store.dispatch('Emails/removeAllUpdateObj', [])

      var myPromise = new Promise(function (resolve) {
        let query = view.$store.getters["Search/getSearchQuery"];
        if (query === null || query === "" || typeof query === "undefined") {
          view.$store.dispatch("Search/setSearchById", false);
          view.$store.dispatch("Search/setSearchBySubject", false);
          view.$store.dispatch("Search/setSearchByBody", false);
          view.$store.dispatch("Search/setSearchBySender", false);

        }
        if (view.oldQuery !== query) {
          view.$store.dispatch("Emails/setSortingField", "email_date");
          view.oldQuery = query;
        }
        resolve(true);
      });
      myPromise
        .then(function () {
          if (view.$utils.isSearchEmpty(view) === false) {
            return view.$store
              .dispatch("Emails/setPage", 1)
              .then(function () {
                return view.$store.dispatch("Emails/setPerPage", 50);
              })
              .then(function () {
                return view.$utils.search(view);
              });
          } else {
            view.showDialog = true;
            view.msg = "Please choose atleast one filter.";
            return Promise.resolve();
          }
        })
        .catch((e) => {
          if (e && (e.is429 || e.status === 429 || (e.response && e.response.status === 429))) {
            this.handle429(e);
          } else {
            console.log(e);
          }
        })
      
    },
    fetchSenderList: function (q) {
      var view = this
      view.$fetch({
        url: view.$url('SENDER_DETAILS'),
        type: 'POST',
        data: JSON.stringify({
          'query': view.$utils.lastelement(q),
          'searchBy': view.$store.getters['Search/getSearchBy'],
        }),
        contentType: "application/json",
      }, {
        operation: 'add',
        vueScope: view
      }).then(function (r) {
        view.senderList = []
        if (r.length) {
          r.forEach(e => view.senderList.push(e))
        }
      })
    },
    chooseSender: function (s) {
      let q = this.$store.getters['Search/getSearchQuery']
      let qt = q.split(',')
      let st = [...qt];
      st.pop()
      const isContained = st.some(element => {
        return element.toLowerCase() === s.trim().toLowerCase();
      });
      if (!isContained) {
        st.push(s.trim())
        qt.push('')
      } else {
        qt.pop()
      }
      if (st[st.length - 1] != '') {
        st.push('')
      }
      this.$store.dispatch('Search/setSearchQuery', st.join(','))
      this.closeSenderList()
    },
    closeSenderList: function () {
      this.senderList = []
    }
  },
  computed: {
    rawDataReady: function () {
      return this.$store.getters["RawData/getIsRawDataReady"];
    },
    from_day: {
      get: function () {
        return this.$store.getters["Search/getFROMDAY"];
      },
      set: function (value) {
        this.$store.dispatch("Search/setFROMDAY", value);
      },
    },
    from_month: {
      get: function () {
        return this.$store.getters["Search/getFROMMONTH"];
      },
      set: function (v) {
        this.$store.dispatch("Search/setFROMMONTH", v);
      },
    },
    from_year: {
      get: function () {
        return this.$store.getters["Search/getFROMYEAR"];
      },
      set: function (v) {
        this.$store.dispatch("Search/setFROMYEAR", v);
      },
    },
    to_day: {
      get: function () {
        return this.$store.getters["Search/getTODAY"];
      },
      set: function (v) {
        this.$store.dispatch("Search/setTODAY", v);
      },
    },
    to_month: {
      get: function () {
        return this.$store.getters["Search/getTOMONTH"];
      },
      set: function (v) {
        this.$store.dispatch("Search/setTOMONTH", v);
      },
    },
    to_year: {
      get: function () {
        return this.$store.getters["Search/getTOYEAR"];
      },
      set: function (v) {
        this.$store.dispatch("Search/setTOYEAR", v);
      },
    },
    email_show_blank: {
      get: function () {
        return this.$store.getters["Search/getSHOWEMAILTYPEBLANK"];
      },
      set: function (v) {
        this.$store.dispatch("Search/setSHOWEMAILTYPEBLANK", v);
      },
    },
    email_show_unused: {
      get: function () {
        return this.$store.getters["Search/getSHOWEMAILTYPEUNUSED"];
      },
      set: function (v) {
        this.$store.dispatch("Search/setSHOWEMAILTYPEUNUSED", v);
      },
    },
    email_show_used: {
      get: function () {
        return this.$store.getters["Search/getSHOWEMAILTYPEUSED"];
      },
      set: function (v) {
        this.$store.dispatch("Search/setSHOWEMAILTYPEUSED", v);
      },
    },
    email_show_junk: {
      get: function () {
        return this.$store.getters["Search/getSHOWEMAILTYPEJUNK"];
      },
      set: function (v) {
        this.$store.dispatch("Search/setSHOWEMAILTYPEJUNK", v);
      },
    },
    email_show_copy: {
      get: function () {
        return this.$store.getters["Search/getSHOWEMAILTYPECOPY"];
      },
      set: function (v) {
        this.$store.dispatch("Search/setSHOWEMAILTYPECOPY", v);
      },
    },
    panelist: {
      get: function () {
        return this.$store.getters["Search/getPANELIST"];
      },
      set: function (v) {
        if (v) {
          if (v.length > 255) {
            alert("Only 255 characters allowed.");
            this.$store.dispatch("Search/setPANELIST", "");
            return true;
          }
        }
        this.$store.dispatch("Search/setPANELIST", v);
      },
    },
    flags_c: {
      get: function () {
        return this.$store.getters["Search/getFLAG_C"];
      },
      set: function (v) {
        this.$store.dispatch("Search/setFLAG_C", v);
      },
    },
    flags_en: {
      get: function () {
        return this.$store.getters["Search/getFLAG_EN"];
      },
      set: function (v) {
        this.$store.dispatch("Search/setFLAG_EN", v);
      },
    },
    flags_n: {
      get: function () {
        return this.$store.getters["Search/getFLAG_N"];
      },
      set: function (v) {
        this.$store.dispatch("Search/setFLAG_N", v);
      },
    },
    flags_rl: {
      get: function () {
        return this.$store.getters["Search/getFLAG_RL"];
      },
      set: function (v) {
        this.$store.dispatch("Search/setFLAG_RL", v);
      },
    },
    flags_tc: {
      get: function () {
        return this.$store.getters["Search/getFLAG_TC"];
      },
      set: function (v) {
        this.$store.dispatch("Search/setFLAG_TC", v);
      },
    },
    flags_tl: {
      get: function () {
        return this.$store.getters["Search/getFLAG_TL"];
      },
      set: function (v) {
        this.$store.dispatch("Search/setFLAG_TL", v);
      },
    },
    flags_ae: {
      get: function () {
        return this.$store.getters["Search/getFLAG_AE"];
      },
      set: function (v) {
        this.$store.dispatch("Search/setFLAG_AE", v);
      },
    },
    flags_po: {
      get: function () {
        return this.$store.getters["Search/getFLAG_PO"];
      },
      set: function (v) {
        this.$store.dispatch("Search/setFLAG_PO", v);
      },
    },
    flags_hr: {
      get: function () {
        return this.$store.getters["Search/getFLAG_HR"];
      },
      set: function (v) {
        this.$store.dispatch("Search/setFLAG_HR", v);
      },
    },
    flags_re: {
      get: function () {
        return this.$store.getters["Search/getFLAG_RE"];
      },
      set: function (v) {
        this.$store.dispatch("Search/setFLAG_RE", v);
      },
    },
    days: function () {
      return this.$store.getters["RawData/getDays"];
    },
    months: function () {
      return this.$store.getters["RawData/getMonths"];
    },
    years: function () {
      return this.$store.getters["RawData/getYears"];
    },
    allFlags: function () {
      return this.$store.getters["RawData/getAllFlags"];
    },
    showemailtype: function () {
      return this.$store.getters["RawData/getShowEmailType"];
    },
    allPartition: function () {
      var storage = window.localStorage.getItem("rawData");
      let data = JSON.parse(storage);
      return data.partition;
    },
    searchownbiz: function () {
      return this.$store.getters["RawData/getSearchOwnBiz"];
    },
    hideMarkedRead: {
      set: function (val) {
        this.$store.dispatch("Search/setHIDEMARKEDREAD", val);
      },
      get: function () {
        return this.$store.getters["Search/getHIDEMARKEDREAD"];
      },
    },
    state: {
      set: function (val) {
        this.$store.dispatch("Search/setSTATE", val);
      },
      get: function () {
        return this.$store.getters["Search/getSelectedState"];
      },
    },
    country: {
      set: function (val) {
        var view = this,
          o = val === "0" ? "all" : val;
        view
          .$fetch({
            url: view.$url("STATES") + "/" + o,
            type: "GET",
          }, {
            operation: 'view',
            vueScope: view
          })
          .then(function (response) {
            view.$store.dispatch("RawData/setStates", []).then(function () {
              view.$store.dispatch("RawData/setStates", response);
              view.states = [];
              view.states.push({ text: "States/Province", value: "" });
              response.forEach(function (o) {
                view.states.push({ text: o.stateName, value: o.stateID });
              });
            });
          });
        view.$store.dispatch("Search/setCOUNTRY", val);
      },
      get: function () {
        return this.$store.getters["Search/getCOUNTRY"];
      },
    },
    businessOwener: {
      set: function (val) {
        this.$store.dispatch("Search/setBUSINESSOWENER", val);
      },
      get: function () {
        return this.$store.getters["Search/getBUSINESSOWENER"];
      },
    },
    searchquery: {
      get: function () {
        return this.$store.getters["Search/getSearchQuery"];
      },
      set: function (o) {
        let view = this,
          searchBy = view.$store.getters['Search/getSearchBy']
        if (searchBy.sender_name || searchBy.sender_email) {
          view.fetchSenderList(o)
        }
        view.$store.dispatch("Search/setSearchQuery", o);
      },
    },
    searchby: {
      get: function () {
        return this.$store.getters["Search/getSearchBy"];
      },
      set: function (v) {
        this.$store.dispatch("Search/setSearchBy", v);
      },
    },
    searchbyid: {
      get: function () {
        return this.$store.getters["Search/getSearchById"];
      },
      set: function (o) {
        if (o === true) {
          this.$store.dispatch("Search/setSearchBySubject", false);
          this.$store.dispatch("Search/setSearchByBody", false);
          this.$store.dispatch("Search/setSearchBySenderName", false);
          this.$store.dispatch("Search/setSearchBySenderEmail", false);
        }
        this.$store.dispatch("Search/setSearchQuery", '');
        this.$store.dispatch("Search/setSearchById", o);
      },
    },
    searchbysubject: {
      get: function () {
        return this.$store.getters["Search/getSearchBySubject"];
      },
      set: function (o) {
        if (o === true) {
          this.$store.dispatch("Search/setSearchById", false);
          this.$store.dispatch("Search/setSearchBySenderName", false);
          this.$store.dispatch("Search/setSearchBySenderEmail", false);
        }
        if (!this.$store.getters['Search/getSearchBy'].body) {
          this.$store.dispatch("Search/setSearchQuery", '');
        }
        this.$store.dispatch("Search/setSearchBySubject", o);
      },
    },
    searchbybody: {
      get: function () {
        return this.$store.getters["Search/getSearchByBody"];
      },
      set: function (o) {
        if (o === true) {
          this.$store.dispatch("Search/setSearchById", false);
          this.$store.dispatch("Search/setSearchBySenderName", false);
          this.$store.dispatch("Search/setSearchBySenderEmail", false);
        }
        if (!this.$store.getters['Search/getSearchBy'].subject) {
          this.$store.dispatch("Search/setSearchQuery", '');
        }
        this.$store.dispatch("Search/setSearchByBody", o);
      },
    },
    searchbysendername: {
      get: function () {
        return this.$store.getters["Search/getSearchBySenderName"];
      },
      set: function (o) {
        if (o === true) {
          this.$store.dispatch("Search/setSearchById", false);
          this.$store.dispatch("Search/setSearchBySubject", false);
          this.$store.dispatch("Search/setSearchByBody", false);
          this.$store.dispatch("Search/setSearchBySenderEmail", false);
        }
        this.$store.dispatch("Search/setSearchQuery", '');
        this.$store.dispatch("Search/setSearchBySenderName", o);
      },
    },
    searchbysenderemail: {
      get: function () {
        return this.$store.getters["Search/getSearchBySenderEmail"];
      },
      set: function (o) {
        if (o === true) {
          this.$store.dispatch("Search/setSearchById", false);
          this.$store.dispatch("Search/setSearchBySubject", false);
          this.$store.dispatch("Search/setSearchByBody", false);
          this.$store.dispatch("Search/setSearchBySenderName", false);
        }
        this.$store.dispatch("Search/setSearchQuery", '');
        this.$store.dispatch("Search/setSearchBySenderEmail", o);
      },
    },
    pan: function () {
      return this.$store.getters["Emails/getRequestPayload"].panelist;
    },
    flags_id: {
      get: function () {
        return this.$store.getters["Search/getFLAG_ID"];
      },
      set: function (v) {
        this.$store.dispatch("Search/setFLAG_ID", v);
      },
    },
    flags_pt: {
      get: function () {
        return this.$store.getters["Search/getFLAG_PT"];
      },
      set: function (v) {
        this.$store.dispatch("Search/setFLAG_PT", v);
      },
    },
    flags_pn: {
      get: function () {
        return this.$store.getters["Search/getFLAG_PN"];
      },
      set: function (v) {
        this.$store.dispatch("Search/setFLAG_PN", v);
      },
    },
  },
  watch: {
  }
};
</script>
<style lang="sass" scoped>
@import "./../assets/sass/search.sass"
</style>
